export const T = {
  en_GB: {
    private: (owner: string) => `Private — only ${owner} can see this client`,
    privateNoOwner: "Private — only the owner can see this client",
    team: (teams: string) => `Limited to: ${teams}`,
    teamGeneric: "Limited to the owner and selected teams",
  },
  nb_NO: {
    private: (owner: string) => `Privat — bare ${owner} kan se denne kunden`,
    privateNoOwner: "Privat — bare eieren kan se denne kunden",
    team: (teams: string) => `Begrenset til: ${teams}`,
    teamGeneric: "Begrenset til eieren og utvalgte team",
  },
} as const;
